import React, { useEffect, useState, useRef } from "react";
import { peticionLoginIframe } from './AuditoriaUnidades.integracion'
import { desEncriptar } from "../../../utilidades/encriptacion";
const AuditoriaUnidades = () => {
    const iframeRef = useRef(null);
    const token = sessionStorage.getItem('token_auditoria');
    useEffect(() => {
        const handleLoad = () => {
          if (iframeRef.current) {
            iframeRef.current.contentWindow.postMessage({ token }, process.env.REACT_APP_AUDITORIAS);
          }
        };
    
        if (iframeRef.current) {
          iframeRef.current.addEventListener('load', handleLoad);
        }
    
        return () => {
          if (iframeRef.current) {
            iframeRef.current.removeEventListener('load', handleLoad);
          }
        };
      }, [token]);
    

    
    return (
        <iframe ref={iframeRef} src= {process.env.REACT_APP_AUDITORIAS+'/historialAdmin'} width="100%" height="95%" />
    );
}

export default AuditoriaUnidades